export const MAIN = '/';
export const CONFIG_PAGE = '/config';
export const CITY_SELECT = '/cidade';
export const HOME = '/picos_pi/home';
